module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_header-ffca2e0b48bb1f9188336053369a721a.png";